import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=a51af362"
import script from "./Color.vue?vue&type=script&lang=js"
export * from "./Color.vue?vue&type=script&lang=js"
import style0 from "./Color.vue?vue&type=style&index=0&id=a51af362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports